<template>
  <main class="w-100">
    <div class="col-4">
      <h4>Deleted Domains</h4>
    </div>
    <LoadingSpinner v-if="!completeLoading" />
    <div v-else>
      <div class="col-12 px-0" v-if="withInputRange">
        <div class="container-fluid w-100 mb-3 p-3 border bg-white rounded stats-wrapper">
          <div class="d-flex flex-wrap">
            <!-- MONTH SELECTION -->
            <div class="w-25 input-group input-group-sm p-1">
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-sm">Period</span>
              </div>
              <date-picker
                class="form-control"
                v-model="filterYearMonth"
                :config="datePickerConfig"
                placeholder="Select Month"
                :disabled="!completeLoading"
              />
            </div>

            <!-- CLIENT SELECTION -->
            <div class="w-25 input-group input-group-sm p-1 treeselect-wrapper">
              <div class="input-group-prepend">
                <span class="input-group-text" id="inputGroup-sizing-sm">Client</span>
              </div>
              <treeselect 
                v-model="filters.client" 
                class="form-control inline-table" 
                :options="filteredClients"
                :multiple="false" 
                :searchable="true" 
                :clearable="true" 
                :loading="isLoading"
                placeholder="Search and select client" 
                label="label" 
                track-by="id" 
                @search-change="onSearchChange"
              ></treeselect>
            </div>

            <!-- SEARCH BUTTON -->
            <div class="w-25 p-1 ml-auto">
              <div class="col-md-12 d-flex justify-content-end my-2">
                <button 
                  class="btn btn-success" 
                  :disabled="!completeLoading" 
                  @click="getDomainsToDelete()"
                >
                  <i class="icon-calendar-check-o mr-2"></i>
                  <small>Search Domains</small>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12 w-100 mb-3 card p-2">
        <div v-if="completeLoading && total > 0" class="row">
          <div class="col-md-12">
            <div class="bd-highlight">
               Total:
              <small v-if="!total" class="ml-1 text-primary">Calculating...</small>
              <strong v-else>{{ total }}</strong>
              <button class="ml-2 btn btn-sm btn-primary" @click="download()">Download csv</button>
            </div>
          </div>
        </div>

        <!-- DATA TABLE -->
        <div class="col-md-12 px-0 mx-0 table-responsive">
          <Table 
            :key="3232323" 
            :headers="simpleheader" 
            :cols="simplecols" 
            :data="list" 
            :checkbox="false"
            :notselect="true" 
            :model="[]"
            @openClient="openClient"
            @changeStatusDomainDelete="changeStatusDomainDelete"
          ></Table>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapState } from "vuex";
import { monitorService } from "@/_services";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Table from "@/components/Common/Table.vue";
import moment from "moment";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  name: "ListDeleteDomain",
  components: { Table, LoadingSpinner, Treeselect },
  props: {
    withInputRange: {
      type: Boolean,
      default: true
    },
    clientId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      isLoading: false,
      completeLoading: false,
      total: 0,
      list: [],
      clients: [],
      filteredClients: [],
      filterYearMonth: moment().format("YYYY-MM"),
      filters: {
        client: null
      },
      simpleheader: [
        {
          label: "Client",
          class: "overflowhide"
        },
        {
          label: "Client Sttaus",
          class: "overflowhide"
        },
        {
          label: "Domain",
          class: "overflowhide"
        }, 
        {
          label: "Total Email Active",
          class: "overflowhide"
        },        
        {
          label: "Delete date",
          class: "overflowhide"
        },
        {
          label: "Month",
          class: "overflowhide"
        },
        {
          label: "Action",
          class: "overflowhide"
        }
      ],
      simplecols: [
        [
          {
            value_label: "client_name",
            value_emit: "client_id",
            // class: "text-primary",
            type: "emit",
            emit: "openClient",
          },
        ],
        [
          {
            value: "client_status",               
            class: "text-primary"
          }
        ], 
        [
          {
            value: "domain",               
            class: "text-primary"
          }
        ],       
        [
          {
            value: "total_email_active",               
            class: "text-primary"
          }
        ],    
        [
          {
            value: "last_removed",
            class: "text-primary"
          }
        ],
        [
          {
            value: "months_since_removed",
            class: "text-primary"
          }
        ],
        [
          // RUN Mark as done
          {
            value: "action_done_staus",
            btnId: "domain",
            type: "btnAction",
            name: "done_staus",
            disabled:[],
            disabled:['1'], //Valores con lo que el boton se mostrara deshabilitado.
            loading_data:['2'], //valores con lo que el boton mostrara como Loading...
            emit:"changeStatusDomainDelete"
          },
        ],        
      ],
      datePickerConfig: {
        format: "YYYY-MM",
        viewMode: "months",
        minDate: moment().subtract(12, "month"),
        maxDate: moment().endOf("day")
      }
    };
  },

  created() {
    this.getClients();
    this.getDomainsToDelete();
  },

  computed: {
    ...mapState({
      currentUser: state => state.authentication.user
    })
  },


  methods: {
    download() {   

      const nameDocument = "report-list-delete-domains.csv";

      //Tomo headers desde simpleheader
      const headers = this.simpleheader.map(h => h.label);

      const fields = this.simplecols.map( item => {
        const value = (item[0].value) ? item[0].value : item[0].value_label;
        return value;
      })

      const rows = this.list.map( item => {
        return fields.map( col => {
          return item[col];
        }).map(v => `"${String(v !== undefined && v !== null ? v : '').replace(/"/g, '""')}"`).join(",");
      })

      const csv = `${headers.join(",")}\n${rows.join("\n")}`;
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", nameDocument);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      },
    onSearchChange(searchQuery) {
      if (searchQuery.length > 1) {
        const query = searchQuery.toLowerCase();
        this.filteredClients = this.clients.filter((client) =>
          client.label.toLowerCase().includes(query)
        );
      } else {
        this.filteredClients = [];
      }
    },

    changeStatusDomainDelete(domain) {
      const domainCurrentStatus = this.list.find(item => item.domain === domain).action_done_staus;      
      const newStatus = domainCurrentStatus == '1' ? '0' : '1';
      
      // Mostrar confirmación antes de proceder
      this.$swal({
        type: "warning",
        title: this.$t("lang.label.are_you_sure"),        
        html: this.$t("lang.label.change_status_domain_delete") + ' - ' + `<strong>${domain}</strong>`,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: this.$t("lang.button.yes"),
        cancelButtonText: this.$t("lang.button.cancel")
      }).then(result => {
        if (result.value == true) {
          // Solo proceder si el usuario confirma
          monitorService.changeStatusDomainDelete(domain, newStatus)
            .then(() => {
              const item = this.list.find(item => item.domain === domain)
              item.action_done_staus = newStatus;
              item.done_staus = (newStatus == '1') ? "Done" : 'Mark as done';
            })
            .catch(err => console.log(err));
        }
      });
    },

    getClients() {
      const toCreateUser = 1;
      monitorService.getClients(null, "2,3,4,5,9", toCreateUser)
        .then(res => {
          this.clients = res;
          if (this.filters.client) {
            this.filteredClients = this.clients.filter(client => client.id == this.filters.client);
          }
        })
        .catch(err => console.log(err));
    },
    
    openClient(client_id) {
      //"client_id", client_id);
      let url = "/clients/" + client_id;
      window.open(url, "_blank");
    },

    getDomainsToDelete() {
      this.completeLoading = false;

      // Calculate start and end dates of the selected month
      const startDate = moment(this.filterYearMonth).startOf('month').format('YYYY-MM-DD');
      const endDate = moment(this.filterYearMonth).endOf('month').format('YYYY-MM-DD');

      const params = {
        start_date: startDate,
        end_date: endDate,
        client_id: this.filters.client || 0,
        total_email_active: 0
      };

      monitorService.getListDeleteDomains(params)
        .then(result => {
          if (result && result.result) {
            this.list = result.result;
            this.total = result.result.length;
          } else {
            this.list = [];
            this.total = 0;
          }
          this.completeLoading = true;
        })
        .catch(error => {
          console.error('Error fetching domains to delete:', error);
          this.list = [];
          this.total = 0;
          this.completeLoading = true;
        });
    }
  }
};
</script>

